// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__sChpf","title":"Card_title__3WHeg","body":"Card_body__jnhJI","action":"Card_action__3Pu-z"};